import * as React from 'react';
import { SelectToggleButton, TileLayout } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { getDiscountPerPack } from '../../../../../utils/cart-discounts.js';
import '@swc/helpers';
import '@grandvisionhq/inventory';
import { PriceAside } from '../PriceAside/PriceAside.js';

const QuantityDiscountItemLayout = ({ item , price , priceIsCentAmount , currency , selectedValue , onChange ,  })=>{
    const { locale , getFormattedLabel , getLabel  } = useIntl();
    const discountedPrice = price - getDiscountPerPack(price, item.amount, item.type, priceIsCentAmount);
    const formattedPrice = formatPrice({
        locale,
        value: discountedPrice,
        currency,
        isCentAmount: !!priceIsCentAmount
    });
    const title = getFormattedLabel('products.contactLenses.quantityDiscountSelect.title', {
        labelData: {
            minimumQuantity: item.minimumQuantity,
            price: formattedPrice
        }
    });
    const isSelected = selectedValue === item.minimumQuantity;
    return /*#__PURE__*/ React.createElement(SelectToggleButton, {
        value: item,
        isSelected: isSelected,
        onClick: ()=>onChange(!isSelected ? {
                quantity: item.minimumQuantity,
                originalUnitPrice: price,
                discountedUnitPrice: discountedPrice
            } : undefined)
        ,
        "data-t": `quantity-discount-select-${item.minimumQuantity}`
    }, /*#__PURE__*/ React.createElement(TileLayout, {
        title: title,
        subtitle: getLabel('products.contactLenses.quantityDiscountSelect.subTitle'),
        aside: /*#__PURE__*/ React.createElement(PriceAside, {
            item: item,
            currency: currency
        }),
        className: "quantity-discount-select__tile"
    }));
};

export { QuantityDiscountItemLayout };
//# sourceMappingURL=QuantityDiscountItemLayout.js.map
